export default __webpack_public_path__ + "static/media/pokemon.17b2d8c1.svg";